import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_STORE_BY_ID } from "../../../../../../../queries/v3/pages/CancelAppointment/queries/get-store-by-id.js";
import { fromStoreByIdQueryToStore } from "../../../../../adapters/v3/pages/CancelAppointment/hooks/api/adapters/fromStoreByIdQueryToStore.js";
const useStoreById = (variables) => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(GET_STORE_BY_ID, {
    variables,
    context: {
      forwardHeaders: {
        "Accept-Language": locale
      }
    }
  });
  const data = React.useMemo(() => {
    return queryState.data?.store ? fromStoreByIdQueryToStore(queryState.data.store) : null;
  }, [queryState]);
  return React.useMemo(
    () => [
      query,
      {
        ...queryState,
        data
      }
    ],
    [data, queryState, query]
  );
};
export {
  useStoreById as default
};
//# sourceMappingURL=use-store-by-id.js.map
